(function () {
class $7b47c552f71bcaf1$var$LSGRewardsPopup extends HTMLElement {
    constructor(){
        super();
        this.timeToFire = parseInt(this.dataset.timeToFire, 10);
        this.disabled = this.dataset.disabled ?? false;
        this.overlay = this;
        this.card = this.querySelector('.loyalty-rewards-popup__card');
        this.closeEls = this.querySelectorAll('.loyalty-rewards-popup__close');
        this._onOverlayClick = (e)=>{
            if (!this.card || !this.card.contains(e.target)) this.close();
        };
        this._onEsc = (e)=>{
            if (e.key === 'Escape') this.close();
        };
    }
    connectedCallback() {
        if (this.disabled) return;
        this.addEventListener('click', this._onOverlayClick);
        this.closeEls.forEach((el)=>{
            el.addEventListener('click', ()=>this.close());
            if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
            if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
            el.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this.close();
                }
            });
        });
        document.addEventListener('keydown', this._onEsc);
        this.showPopup();
    }
    get cookieName() {
        return this.dataset.cookieKey || 'lsg_rewards_popup_blocked';
    }
    isBlocked() {
        return document.cookie.split('; ').some((c)=>c.startsWith(this.cookieName + '='));
    }
    setBlockCookie() {
        document.cookie = `${this.cookieName}=1; Max-Age=259200; Path=/`;
    }
    showPopup() {
        this.handleTimeTrigger();
    }
    handleTimeTrigger() {
        if (this.timeToFire) setTimeout(()=>this.open(), this.timeToFire * 1000);
    }
    disconnectedCallback() {
        this.removeEventListener('click', this._onOverlayClick);
        document.removeEventListener('keydown', this._onEsc);
    }
    open() {
        if (this.isBlocked() || this.disabled) return;
        this.classList.remove('hidden');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
    }
    close() {
        this.setBlockCookie();
        this.classList.add('hidden');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
    }
}
customElements.define('lsg-rewards-popup', $7b47c552f71bcaf1$var$LSGRewardsPopup);

})();
